module.exports = __webpack_public_path__ + "img/collapse.8dbc8c23.svg";